import { TextField } from '@mui/material';

type PercentInputProps = {
  value: string | number;
  onChange: (value: string) => void; // Não precisa passar o evento, só o valor já validado
  label?: string;
};

export default function PercentInput({ value, onChange, label }: PercentInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(',', '.');

    if (/^\d*([.,]\d{0,2})?$/.test(rawValue)) {
      onChange(rawValue);
    }
  };

  return (
    <TextField
      type="text"
      value={value}
      onChange={handleChange}
      variant="outlined"
      size="small"
      sx={{ width: 100 }}
      label={label}
    />
  );
}
